import React, { useEffect, useState } from 'react';
import { getAdminAuthHeader } from '../services/auth';

const AuthenticatedImage = ({ src, alt = '', onError, ...props }) => {
  const [imageUrl, setImageUrl] = useState('');

  useEffect(() => {
    let objectUrl;
    let cancelled = false;

    if (!src) {
      setImageUrl('');
      return undefined;
    }

    // Public images remain supported; private /files images are fetched with auth.
    if (!src.includes('/files/')) {
      setImageUrl(src);
      return undefined;
    }

    fetch(src, { headers: getAdminAuthHeader() })
      .then((response) => {
        if (!response.ok) throw new Error(`Image request failed (${response.status})`);
        return response.blob();
      })
      .then((blob) => {
        if (!cancelled) {
          objectUrl = URL.createObjectURL(blob);
          setImageUrl(objectUrl);
        }
      })
      .catch((error) => {
        if (!cancelled) onError?.(error);
      });

    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [src, onError]);

  return imageUrl ? <img src={imageUrl} alt={alt} {...props} /> : null;
};

export default AuthenticatedImage;
